// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4acc9a8bccb52989c1428514c46a77b6823dfc67/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};